<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md1>
        <v-card>
          <v-card-title>
            <h4>Free Samples</h4>
            <v-spacer></v-spacer>
            <v-btn small @click="searchFreeSamples()" color="primary" :loading="freeSamplesLoading" :disabled="freeSamplesLoading" fab flat>
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="headers" :items="orders" :loading="freeSamplesLoading" :pagination.sync="pagination" :total-items="totalFreeSamples" :rows-per-page-items="rowsPerPageItems">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.orderCode }} <span v-if="props.item.status === 'Cart'">({{props.item.status}})</span></td>
                <td v-if="props.item.customerID"><v-btn small flat color="primary" @click="onClickingCustomerName(props.item._id)">{{ props.item.customerID ? props.item.customerID.firstName + ' ' + props.item.customerID.lastName : ''}}</v-btn></td>
                <td v-else></td>
                <td>{{ props.item.freeSamples[0] }}</td>
                <td>{{ new Date(props.item.date).getDate() + "/" + (new Date(props.item.date).getMonth() + 1) + "/" + new Date(props.item.date).getFullYear() }}</td>
                <td v-if="props.item.status == 'Sent to Customer'">Yes</td>
                <td v-else>No</td>
                <td>
                  <v-select @change="freeSampleActions" :items="[{ text: 'Edit', value: { action: 'edit', id: props.item._id } },
                    { text: 'Email Confirmation', value: { action: 'email', id: props.item._id } },
                    { text: 'Delete', value: { action: 'delete', id: props.item._id }}]" label="Actions"></v-select>
                </td>
              </template>
              <template slot="no-data">
                {{ loadingText }}
              </template>
              <template slot="no-results">
                Your search for '{{ search }}' didn't return any results.
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md2>
        <v-card>
          <v-card-title>
            <h4>Search and Filter</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <!-- <v-select v-model="enabledStatuses" :items="availableStatuses" chips clearable label="Filter Status" multiple @input="searchOrders()"></v-select>
            <v-spacer></v-spacer> -->
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details @change="searchFreeSamples()"></v-text-field>
            <v-spacer class="v-text-field"></v-spacer>
            <!-- <v-select v-model="enabledSentOrNot" :items="availableSentOrNot" chips clearable label="Filter Sent Status" multiple @input="searchFreeSamples()"></v-select> -->
            <v-btn color="primary" @click="oldOrdersDialog = true">Show Old Orders</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- Old Orders Popup -->
    <v-dialog v-model="oldOrdersDialog" max-width="600px">
      <v-card>
        <v-card-title><h2>Search Old Free Sample Orders</h2></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field v-model="searchSent" append-icon="search" label="Search" single-line hide-details @change="searchSentFreeSamples()"></v-text-field>
          <v-divider></v-divider>
          <table width='100%' class="mt-4" v-if='sentOrders.length'>
            <tr class="text-xs-center">
              <th>Order Code</th>
              <th>Name</th>
              <th>Samples</th>
              <th>Date</th>
            </tr>
            <tr v-for="(order,index) in sentOrders" :key="index" class="text-xs-center">
              <td><v-btn small flat color="primary" @click="$router.push({ path: `/freeSampleOrder/${order._id}` })">{{order.orderCode}}</v-btn></td>
              <td v-if="order.customerID"><v-btn small flat color="primary" @click="onClickingCustomerNameSent(order._id)">{{ order.customerID ? order.customerID.firstName + ' ' + order.customerID.lastName : ''}}</v-btn></td>
              <td v-else></td>
              <td>{{order.freeSamples[0]}}</td>
              <td>{{ new Date(order.date).getDate() + "/" + (new Date(order.date).getMonth() + 1) + "/" + new Date(order.date).getFullYear() }}</td>
            </tr>
          </table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="oldOrdersDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Customer Popup -->
    <v-dialog v-model="freeSampleCustomerDialog" max-width="600px">
      <v-card v-if="selectedOrder">
        <v-card-title>{{ selectedOrder.orderCode }} - Customer Details</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Name: {{ selectedOrder.customerID.firstName }} {{ selectedOrder.customerID.lastName }}</p>
          <p>Phone: {{ selectedOrder.customerID.phone }}</p>
          <p>Email: {{ selectedOrder.customerID.email }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="freeSampleCustomerDialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat target="_blank" :to="`/customers/${selectedOrder.customerID._id}`">Go to Customer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import FreeSampleService from '@/services/FreeSampleService'
import OrderService from '@/services/OrderService'
export default {
  name: 'freeSamples',
  data () {
    return {
      orders: [],
      sentOrders: [],
      headers: [
        { text: 'Order Code', value: 'orderCode' },
        { text: 'Name', value: 'name' },
        { text: 'Samples', value: 'samples' },
        { text: 'Date', value: 'date' },
        { text: 'Sent?', value: 'sent' },
        { text: 'Actions', value: 'actions' }
      ],
      freeSamplesLoading: true,
      search: null,
      searchSent: null,
      popupText: null,
      snackbar: false,
      oldOrdersDialog: false,
      freeSampleCustomerDialog: false,
      selectedOrder: null,
      pagination: {
        sortBy: 'date',
        descending: true,
        rowsPerPage: 30
      },
      totalFreeSamples: 0,
      loadingText: 'Loading...',
      rowsPerPageItems: [10, 20, 30],
      enabledSentOrNot: ['Yes', 'No'],
      availableSentOrNot: ['Yes', 'No']
    }
  },
  mounted () {
    // this.getFreeSamples()
  },
  watch: {
    pagination: {
      handler () {
        this.getFreeSamples().then(data => {
          this.orders = data
        })
      },
      deep: true
    }
  },
  methods: {
    async getFreeSamples () {
      this.freeSamplesLoading = true

      const { sortBy, descending, page, rowsPerPage } = this.pagination

      const response = await FreeSampleService.getLimitedFreeSamples(page, rowsPerPage, this.search, ['No'])

      let items = response.data.freeSamples

      if (this.pagination.sortBy) {
        items = items.sort((a, b) => {
          const sortA = a[sortBy]
          const sortB = b[sortBy]

          if (descending) {
            if (sortA < sortB) return 1
            if (sortA > sortB) return -1
            return 0
          } else {
            if (sortA < sortB) return -1
            if (sortA > sortB) return 1
            return 0
          }
        })
      }

      const totalResponse = await FreeSampleService.countFreeSamples(this.search, this.enabledSentOrNot)
      this.totalFreeSamples = totalResponse.data.count

      if (this.totalFreeSamples === 0) {
        this.loadingText = 'No Free Samples Found.'
      }

      this.freeSamplesLoading = false

      return items
    },

    async searchFreeSamples () {
      this.orders = await this.getFreeSamples()
    },

    async searchSentFreeSamples () {
      const { sortBy, descending, page, rowsPerPage } = this.pagination

      const response = await FreeSampleService.getLimitedFreeSamples(page, rowsPerPage, this.searchSent, ['Yes'])

      let items = response.data.freeSamples
      if (this.pagination.sortBy) {
        items = items.sort((a, b) => {
          const sortA = a[sortBy]
          const sortB = b[sortBy]

          if (descending) {
            if (sortA < sortB) return 1
            if (sortA > sortB) return -1
            return 0
          } else {
            if (sortA < sortB) return -1
            if (sortA > sortB) return 1
            return 0
          }
        })
      }
      this.sentOrders = items
    },

    async deleteFreeSample (id) {
      this.freeSamplesLoading = true
      const response = await OrderService.deleteOrder(id)
      if (response.data.success) {
        this.popupText = 'Free sample order deleted successfully'
        this.snackbar = true
        this.getFreeSamples()
      }
    },

    async emailConfirmation (id) {
      const response = await OrderService.emailFreeSampleConfirmation(id)
      if (response.data.success) {
        this.popupText = 'Confirmation sent successfully'
        this.snackbar = true
      }
    },

    async emailTracking (id) {
      const response = await OrderService.emailTrackingUpdate(id)
      if (response.data.success) {
        this.popupText = 'Email tracking update sent successfully'
        this.snackbar = true
      }
    },

    freeSampleActions (value) {
      switch (value.action) {
        case 'edit':
          this.$router.push({ path: `/freeSampleOrder/${value.id}` })
          break
        case 'delete':
          this.deleteFreeSample(value.id)
          break
        case 'email':
          this.emailConfirmation(value.id)
          break
        case 'tracking':
          this.emailTracking(value.id)
          break
      }
    },

    onClickingCustomerName (orderID) {
      this.selectedOrder = this.orders.find(function (order) {
        if (order._id === orderID) {
          return order
        }
      })
      this.freeSampleCustomerDialog = true
    },
    onClickingCustomerNameSent (orderID) {
      this.selectedOrder = this.sentOrders.find(function (order) {
        if (order._id === orderID) {
          return order
        }
      })
      this.freeSampleCustomerDialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/freeSamples/FreeSamples.vue